export function getDateString(date) {
  const dateString = `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}-${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`
  return dateString
}

export function getNowDateString() {
  const now = new Date()
  const dateString = getDateString(now)
  return dateString
}
